import { createContext, ReactNode, useContext } from 'react';
import { CampaignProps } from '~/types/Campaign';

interface CampaignContextProps {
  campaign?: CampaignProps;
}

const CampaignContext = createContext<CampaignContextProps | undefined>(
  undefined
);

export const useCampaign = () => {
  return useContext(CampaignContext) ?? {};
};

interface CampaignProviderProps {
  campaign: CampaignProps;
  children: ReactNode;
}

export const CampaignProvider = ({
  campaign,
  children,
}: CampaignProviderProps) => {
  return (
    <CampaignContext.Provider value={{ campaign }}>
      {children}
    </CampaignContext.Provider>
  );
};
